import { axiosInstance } from "./AxiosDefaults";
import { warehousesRoute } from "../constants/ApiRoutes";
import { Warehouse } from "../models/Warehouse";

export type ApiResponse<T> = {
  status?: "SUCCESS" | "ERROR";
  message?: string;
  result?: T;
};

export const getAllWarehouses = (): Promise<any> => {
  return axiosInstance.get(warehousesRoute, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const createWarehouse = (payload: Partial<Warehouse>): Promise<any> => {
  return axiosInstance.post(warehousesRoute, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const updateOneWarehouse = (
  id: string,
  payload: Partial<Warehouse>
): Promise<any> => {
  return axiosInstance.put(`${warehousesRoute}/${id}`, payload, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};
